import { Entity } from '@toeverything/infra';

export class SidebarTab extends Entity<{ id: string; label?: string }> {
  readonly id = this.props.id;
  readonly label = this.props.label;
}
